export default __webpack_public_path__ + "static/media/Asset 10.e0696414.png";